import React, { memo } from 'react';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import { ImgWrap } from 'pubBiz';

const mainPicWidth = '3.42rem';

const defaultProps = {
  data: [],
  onPress: null
};

// imgInfo成员结构
const imgInfoPropTypes = PropTypes.shape({
  imgUrl: PropTypes.string
});

const dataPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    imgInfo: imgInfoPropTypes.isRequired,
    id: PropTypes.string,
    type: PropTypes.string,
    content: PropTypes.string,
    extend: PropTypes.object
  })
);

const propTypes = {
  width: PropTypes.any.isRequired, // 容器宽度
  data: dataPropTypes, // 数据源
  multipleMargin: PropTypes.number, // 间隙间距
  onPress: PropTypes.func // 点击事件
};

const AsymmetricGrid = memo((props) => {
  const {
    combinationType, // 2: 不对称宫格1 3: 不对称宫格2
    width: cellWidth, // Any 容器宽度
    multipleMargin, // Number 间隙间距
    data, // Array 数据源
    onPress // Function 点击事件
  } = props;

  const renderLeft = (item, index) => {
    // 不对称宫格1 图片约定好的宽高比是 171*171
    // 不对称宫格2 图片约定好的宽高比是 171*207
    const { imgInfo } = item;
    const { imgUrl } = imgInfo;
    const imgWidth = mainPicWidth;
    const imgHeight = `calc(${imgWidth} * ${combinationType == 2 ? 171 / 171 : 207 / 171})`;
    return (
      <Flex key={`AsymmetricGrid-left${index}`} onClick={() => onPress && onPress(item)}>
        <ImgWrap src={imgUrl || ''} mode={'cover'} w={imgWidth} h={imgHeight} />
      </Flex>
    );
  };

  const renderRight = (item, index) => {
    // 不对称宫格1 图片约定好的宽高比是 81*171
    // 不对称宫格2 图片约定好的宽高比是 99*171
    const { imgInfo } = item;
    const { imgUrl } = imgInfo;
    const imgWidth = `calc(${cellWidth} - ${multipleMargin} - ${mainPicWidth})`;
    const imgHeight = `calc(${imgWidth} * ${combinationType == 2 ? 81 / 171 : 99 / 171})`;
    return (
      <Flex key={`AsymmetricGrid-right${index}`} onClick={() => onPress && onPress(item)}>
        <ImgWrap src={imgUrl || ''} mode={'cover'} w={imgWidth} h={imgHeight} />
      </Flex>
    );
  };

  // 将数据分成左右两部分，左边部分一张，右边部分两张
  const leftData = (data || []).slice(0, 1);
  const rightData = (data || []).slice(1);

  return (
    <Flex
      direction="row"
      justify="between"
      style={{
        width: cellWidth,
        height: `calc(${mainPicWidth} * ${combinationType == 2 ? 171 / 171 : 207 / 171})`
      }}>
      {leftData.map((item, index) => renderLeft(item, index))}
      <Flex direction="column" justify="between" style={{ height: '100%' }}>
        {rightData.map((item, index) => renderRight(item, index))}
      </Flex>
    </Flex>
  );
});

AsymmetricGrid.defaultProps = defaultProps;
AsymmetricGrid.propTypes = propTypes;

export default AsymmetricGrid;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/RecommandCell/components/AsymmetricGrid/index.js